import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { closedDealsYtd } from '../data/portal';
interface ClosedDealsModalProps {
  open: boolean;
  onClose: () => void;
}
const ease = [0.23, 1, 0.32, 1] as const;
export function ClosedDealsModal({
  open,
  onClose
}: ClosedDealsModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-122" data-mp="c2q8b7n5z60t">
      {open && <motion.div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/40 p-6" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease
    }} onClick={onClose} data-id="element-123" data-mp="c1f27168xm6j">
          <motion.div role="dialog" aria-modal="true" aria-labelledby="closed-title" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease
      }} onClick={e => e.stopPropagation()} className="w-full max-w-lg rounded-2xl bg-white shadow-xl" data-id="element-124" data-mp="3ub8uu1ua135t">
            <div className="flex items-start justify-between px-7 pb-4 pt-6" data-id="element-125" data-mp="3l9mpp6o8v6t9">
              <div data-id="element-126" data-mp="3q8qull44yids">
                <h2 id="closed-title" className="text-lg font-semibold text-slate-900" data-id="element-127" data-mp="3q9925dw90j10">
                  Closed this year
                </h2>
                <p className="mt-1 text-sm text-slate-500" data-id="element-128" data-mp="3cbaoybtnysn3">{closedDealsYtd.length} buyers you referred, Jan – Oct 2026</p>
              </div>
              <button onClick={onClose} aria-label="Close" autoFocus className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-400 transition-[color,background-color,border-color,box-shadow,transform] duration-200 ease-out hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-129" data-mp="20tjep86n6el9">
                <XIcon className="h-5 w-5" data-id="element-130" data-mp="1lt746938v71" />
              </button>
            </div>
            <div className="max-h-[420px] overflow-y-auto px-7 pb-6" data-id="element-131" data-mp="3su70it2q4169">
              <table className="w-full text-sm" data-id="element-132" data-mp="3ortt808bvv7d">
                <thead className="sticky top-0 bg-white" data-id="element-133" data-mp="3oslk4xqzd4rb">
                  <tr className="border-b border-slate-200 text-left text-xs font-medium text-slate-500" data-id="element-134" data-mp="3jt0k0k02qqd0">
                    <th className="py-2.5 font-medium" data-id="element-135" data-mp="3et4cwbw2yit8">Buyer</th>
                    <th className="py-2.5 font-medium" data-id="element-136" data-mp="3evh3tejtg3if">City</th>
                    <th className="py-2.5 text-right font-medium" data-id="element-137" data-mp="39vunuxcls95x">Closed</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-138" data-mp="1d06qaxswcmgq">
                  {closedDealsYtd.map(d => <tr key={d.buyer} data-id="element-139" data-mp="181dd76hiuxh3">
                      <td className="py-3 font-medium text-slate-900" data-id="element-140" data-mp="1gl03pxncg2g8">{d.buyer}</td>
                      <td className="py-3 text-slate-600" data-id="element-141" data-mp="1klaahciymww5">{d.city}</td>
                      <td className="py-3 text-right tabular-nums text-slate-600" data-id="element-142" data-mp="1kjfn7rk7usow">{d.closed}</td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}